var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fav-box",on:{"click":_vm.fav}},[_c('span',{staticClass:"fav"},[_vm._v("收藏")]),_c('span',{class:_vm.isFav == 1 ? 'iconfont icon-buoumaotubiao44': 'iconfont icon-shoucang2'})])
}
var staticRenderFns = []

export { render, staticRenderFns }